import React, { useEffect } from 'react';
import EstimateGrid from '../../../features/cfi/estimate-grid/components/EstimateGrid';
import { useTitle } from "../../../contexts/title";

export default function EstimatesPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Estimates')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<EstimateGrid
					leads={false}
				/>
			</div>
		</React.Fragment>
	)
} 
